import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Button from '@material-ui/core/Button';
import readXlsxFile from "read-excel-file";
import { useDispatch, useSelector } from "react-redux";
import theme from "../../theme";
import CommonButton from "../../components/button";
import { onBoardEmployeesAction, onBoardEmployeesVerifyAction } from "../../containers/companyDashboard/action";
import InfoIcon from "@material-ui/icons/Info";
import { ThreeDotsLoading } from "../loading";
import CommonFormDropDown from "../formdropdown";
import { getAdminWithdrawalCategoriesAction } from "../../containers/companyDashboard/action";
import ValidationErrorList from "./ValidationErrorList";
import {
  employeeImportHeaders,
  isString,
  isNumber,
  isEmail,
  normalizeGender,
} from "./employeeImportValidators";


var fileDownloader, fileUploader;
const headers = employeeImportHeaders;

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "30px 0px",
  },
  container: {
    width: "350px",
    backgroundColor: theme.colors.White,
    boxShadow: "0px 0px 10px #CFD9EA80",
    borderRadius: "15px",
    padding: "50px 60px",
  },
  title: {
    color: theme.colors.DodgerBlue,
    fontSize: "24px",
    fontFamily: theme.fontFamily.MARKPROBOLD,
    marginBottom: "20px",
  },
  subText: {
    color: theme.colors.Violet,
    fontSize: "18px",
    fontFamily: theme.fontFamily.MARKPRO,
    marginBottom: "10px",
  },
  fileContainer: {
    backgroundColor: theme.colors.Zumthor,
    padding: "5px 10px",
    top: "15px",
    position: "relative",
    borderRadius: "3px",
    wordBreak: "break-word",
  },
  fileName: {
    color: theme.colors.DodgerBlue,
    fontSize: "14px",
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
  },
  crossIcon: { marginLeft: "8px", marginBottom: "-4px", cursor: "pointer" },
  bingoImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "40px",
  },
  modalPaper: {
    position: "absolute",
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: '#fff',
    border: '2px solid #000',
    boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.5)',
    padding: 20,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  infoIco: {
    color: theme.colors.DodgerBlueLight,
    // backgroundColor: theme.colors.DodgerBlueLight
  },
  switch: {
    "& .label": {
      fontSize: "18px",
      fontFamily: theme.fontFamily.MARKPROLIGHT
    }
  }

}));

const info = {
  "Default": "Applies Company General Limits To Employees",
  "Level 1": "Applies 20 % Withdrawal Limit To Employees",
  "Level 2": "Applies 45 % Withdrawal Limit To Employees",
  "Level 3": "Applies 70 % Withdrawal Limit To Employees",
  "Level 4": "Applies 100 % Withdrawal Limit To Employees",
}

function InviteEmployees({ setInviteEmployees }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const companyDashboardReducer = useSelector((state) => {
    return state.companyDashboardReducer;
  });
  const dashboardReducer = useSelector((state) => (state.dashboardReducer))
  const getAdminWithdrawalCategoriesActionMethod = React.useCallback(
    (filters) => (dispatch(getAdminWithdrawalCategoriesAction(filters))), [dispatch]);
  const onBoardEmployeesVerifyActionMethod = React.useCallback(
    (data) => (dispatch(onBoardEmployeesVerifyAction(data))), [dispatch]);

  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState([]);
  const [modalStyle] = useState(getModalStyle);
  const [openModal, setOpenModal] = useState(false);
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [level, setLevel] = useState({ label: "Default", value: "0" });
  const [limitCategories, setLimitCategories] = useState([])
  const [isVerified, setIsVerified] = useState(false);
  const [isParsingFile, setIsParsingFile] = useState(false);

  const handleButtonClick = () => {
    setShowModal(true);
  };

  const handleConfirmUpload = () => {
    fileUploader.click();
    setShowModal(false);
  };

  const handleCancelUpload = () => {
    setShowModal(false);
  };

  useEffect(() => {
    getAdminWithdrawalCategoriesActionMethod({ history: 1 })
  }, [])

  useEffect(() => {
    const { onBoardSuccess, error, withdrawalLimitCategories, onBoardVerifySuccess, onBoardVerifyError } = companyDashboardReducer;
    if (onBoardSuccess) {
      setOpenModal(true);
    }
    if (onBoardVerifySuccess || onBoardVerifyError) {
      if (!!onBoardVerifySuccess && !onBoardVerifyError) {
        setIsVerified(!!onBoardVerifySuccess && !onBoardVerifyError);
      } else {
        setOpenVerifyModal(true);
      }
    }

    if (error) {
      if (file) {
        setFile(null);
      }
      if (Array.isArray(error)) {
        setErrors(error);
      } else {
        setErrors([error]);
      }
    } else {
      setErrors([]);
    }

    if (Array.isArray(withdrawalLimitCategories?.data)) {
      let arr = []
      withdrawalLimitCategories.data.forEach((value) => {
        arr.push({ label: value.name, value: value.limit })
        info[value.name] = value.description
      })
      setLimitCategories(arr);
    }
  }, [companyDashboardReducer]);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("user"))?.is_super) {
      let arr2 = []
      const { withdrawalLimitCategories } = dashboardReducer;
      if (Array.isArray(withdrawalLimitCategories)) {
        withdrawalLimitCategories.forEach((value) => {
          arr2.push({ label: value.name, value: value.limit })
          info[value.name] = value.description
        })
        setLimitCategories(arr2)
      }
    }
  }, [dashboardReducer])

  useEffect(() => {
    if (errors && errors.length) {
      const ele = document.getElementsByClassName("error-container");
      if (ele && ele.length) ele[0].scrollIntoView(false);
    }
  }, [errors]);

  useEffect(() => {
    setEmployees((employees) => (employees.map((value) => ({
      withdrawal_percent: level.value, ...value,
    }))))
  }, [level])

  return (
    <div className={classes.root}>
      <Helmet>
        <title>{"Sanaam - Invite Employees"}</title>
        <meta property="og:title" content={"Sanaam - Invite Employees"} />
      </Helmet>
      <ThreeDotsLoading showLoader={companyDashboardReducer?.loading || isParsingFile} />
      <div className={classes.container}>
        <div className={classes.title}>Onboarding Employees</div>
        <div className={classes.subText}>
          <CommonFormDropDown
            label="Percentage Withdrawal Limit Level To Apply To Employees"
            placeholder={"Select Level"}
            disabled={file ? true : false}
            options={[
              { label: "Default", value: "0" },
              ...limitCategories
            ]}
            value={level}
            onChange={(val) => {
              setLevel(val);
            }}
            isSearchable={false}
            isDisabled={
              companyDashboardReducer?.loading
              || companyDashboardReducer.withdrawalLimitCategoriesLoading || dashboardReducer.loading
            }
            error={false}
            helperText={""}
            isLoading={
              companyDashboardReducer?.loading
              || companyDashboardReducer.withdrawalLimitCategoriesLoading || dashboardReducer.loading
            }
          />
          <p
            style={{ fontSize: "0.875rem", color: "#666", flexDirection: "row", alignItems: "center", display: "flex" }}
          >
            <InfoIcon className={classes.infoIco} /> {info[level.label]}
          </p>
        </div>

        <div className={classes.subText}>
          Download our template to import your
          <br /> employees and their data to Sanaam
        </div>
        <div style={{ marginBottom: "40px" }}>
          <CommonButton
            stylevariant="secondary2"
            type="button"
            text={"Download Template"}
            onClick={() => {
              fileDownloader.click();
            }}
            icon={"/images/download.png"}
          />
          <a
            ref={(ref) => (fileDownloader = ref)}
            href={"/Employees template list.xlsx"}
            download={`Employees template list`}
            style={{ display: "none" }}
          >
            download
          </a>
        </div>
        <div className={classes.subText}>
          After downloading and filling our
          <br /> template please upload it here
        </div>
        <div style={{ marginBottom: "40px" }}>
          <CommonButton
            stylevariant="secondary2"
            type="button"
            text={"Upload Employee Sheets"}
            onClick={handleButtonClick}
            icon={"/images/upload.png"}
          />
          <Modal open={showModal} onClose={handleCancelUpload} className={classes.modal}>
            <div className={classes.paper}>
              <p>This action cannot be revoked. Are you sure you want to proceed?</p>
              <div className={classes.buttonContainer}>
                <Button variant="contained" style={{ backgroundColor: '#3E83FA' }} onClick={handleConfirmUpload}>Yes, Proceed</Button>
                <Button variant="contained" style={{ backgroundColor: '#FF3B59' }} onClick={handleCancelUpload}>Cancel</Button>
              </div>
            </div>
          </Modal>
          <input
            type="file"
            ref={(ref) => (fileUploader = ref)}
            style={{ display: "none" }}
            onClick={(event) => {
              event.target.value = null;
            }}
            onChange={(e) => {
              setFile(e.target.files[0]);
              setIsVerified(false);
              setErrors([]);
              setEmployees([]);
              setOpenVerifyModal(false);
              setIsParsingFile(true);
              readXlsxFile(e.target.files[0]).then((rows) => {
                let array = [],
                  errorMessageArray = [];

                if (rows && rows.length > 1) {
                  for (let i = 1; i < rows.length; i++) {
                    let entry = {};
                    for (let j = 0; j < headers.length; j++) {
                      entry[headers[j]] = rows[i][j];
                    }
                    array.push(entry);
                  }

                  for (let i = 0; i < array.length; i++) {
                    const element = array[i];

                    if (
                      (!element["First Name"] ||
                        !element["First Name"]?.trim()) &&
                      errorMessageArray.indexOf(
                        "First Name may not be blank."
                      ) < 0
                    ) {
                      errorMessageArray.push("First Name may not be blank.");
                    } else if (
                      element["First Name"]?.trim() &&
                      element["First Name"]?.trim().length > 24 &&
                      errorMessageArray.indexOf(
                        "Ensure First Name has no more than 24 characters."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Ensure First Name has no more than 24 characters."
                      );
                    } else if (
                      element["First Name"]?.trim() &&
                      !element["First Name"]
                        ?.trim()
                        .toString()
                        .match(isString) &&
                      errorMessageArray.indexOf(
                        "First Name should contain only letters and spaces. Numbers and special characters are not allowed."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "First Name should contain only letters and spaces. Numbers and special characters are not allowed."
                      );
                    }

                    if (
                      (!element["Last Name"] || !element["Last Name"]?.trim()) &&
                      errorMessageArray.indexOf("Last Name may not be blank.") <
                      0
                    ) {
                      errorMessageArray.push("Last Name may not be blank.");
                    } else if (
                      element["Last Name"]?.trim() &&
                      element["Last Name"]?.trim().length > 24 &&
                      errorMessageArray.indexOf(
                        "Ensure Last Name has no more than 24 characters."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Ensure Last Name has no more than 24 characters."
                      );
                    } else if (
                      element["Last Name"]?.trim() &&
                      !element["Last Name"]?.trim().toString?.()?.match?.(isString) &&
                      errorMessageArray.indexOf(
                        "Last Name should contain only letters and spaces. Numbers and special characters are not allowed."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Last Name should contain only letters and spaces. Numbers and special characters are not allowed."
                      );
                    }

                    if (
                      (!element["Gender"] || !element["Gender"]?.trim()) &&
                      errorMessageArray.indexOf("Gender may not be blank.") < 0
                    ) {
                      errorMessageArray.push("Gender may not be blank.");
                    } else if (
                      element["Gender"]?.trim()
                    ) {
                      const normalizedGender = normalizeGender(element["Gender"]);
                      if (
                        normalizedGender !== "M" &&
                        normalizedGender !== "F"
                      ) {
                        if (errorMessageArray.indexOf("Gender should be M/F, Male/Female, or male/female.") < 0) {
                          errorMessageArray.push("Gender should be M/F, Male/Female, or male/female.");
                        }
                      } else {
                        // Normalize the gender value in the element
                        element["Gender"] = normalizedGender;
                      }
                    }

                    if (
                      (!element["Email"] || !element["Email"]?.trim()) &&
                      errorMessageArray.indexOf("Email may not be blank.") < 0
                    ) {
                      errorMessageArray.push("Email may not be blank.");
                    } else if (
                      element["Email"]?.trim() &&
                      !element["Email"]?.trim().toString?.()?.match?.(isEmail) &&
                      errorMessageArray.indexOf(
                        "Email should be in proper format."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Email should be in proper format."
                      );
                    }

                    if (
                      (!element["Phone number"] ||
                        (element["Phone number"] && !Number.toString(element["Phone number"]).trim())) &&
                      errorMessageArray.indexOf(
                        "Phone number may not be blank."
                      ) < 0
                    ) {
                      errorMessageArray.push("Phone number may not be blank.");
                    }

                    if (
                      (!element["Title"] || !element["Title"]?.trim()) &&
                      errorMessageArray.indexOf("Job Title may not be blank.") <
                      0
                    ) {
                      errorMessageArray.push("Job Title may not be blank.");
                    } else if (
                      element["Title"]?.trim() &&
                      element["Title"]?.trim().length > 24 &&
                      errorMessageArray.indexOf(
                        "Ensure Job Title has no more than 24 characters."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Ensure Job Title has no more than 24 characters."
                      );
                    } else if (
                      element["Title"]?.trim() &&
                      !element["Title"]?.trim().toString?.()?.match?.(isString) &&
                      errorMessageArray.indexOf(
                        "Job Title should contain only letters and spaces. Numbers and special characters are not allowed."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Job Title should contain only letters and spaces. Numbers and special characters are not allowed."
                      );
                    }

                    if (
                      !element["Full Net Salary"] &&
                      errorMessageArray.indexOf(
                        "Full Salary may not be blank."
                      ) < 0
                    ) {
                      errorMessageArray.push("Full Salary may not be blank.");
                    } else if (
                      element["Full Net Salary"] &&
                      !element["Full Net Salary"]?.toString?.()?.match?.(isNumber) &&
                      errorMessageArray.indexOf(
                        "Full Salary should contain only numbers and decimal point. Letters and special characters (except decimal point) are not allowed."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Full Salary should contain only numbers and decimal point. Letters and special characters (except decimal point) are not allowed."
                      );
                    }

                    if (
                      !element["Savings"] &&
                      errorMessageArray.indexOf("Savings may not be blank.") < 0
                    ) {
                      errorMessageArray.push("Savings may not be blank.");
                    } else if (
                      element["Savings"] &&
                      !element["Savings"]?.toString?.()?.match?.(isNumber) &&
                      errorMessageArray.indexOf(
                        "Savings should be number only."
                      ) < 0
                    ) {
                      errorMessageArray.push("Savings should be number only.");
                    } else if (
                      element["Full Net Salary"] &&
                      element["Savings"] &&
                      element["Savings"] >= element["Full Net Salary"] &&
                      errorMessageArray.indexOf(
                        "Savings should be less than Full Salary."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Savings should be less than Full Salary."
                      );
                    }

                    if (
                      (!element["Account holder name"] ||
                        !element["Account holder name"]?.trim()) &&
                      errorMessageArray.indexOf(
                        "Account Holder Name may not be blank."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Account Holder Name may not be blank."
                      );
                    } else if (
                      !element["Account holder name"] &&
                      errorMessageArray.indexOf(
                        "Account Holder Name Should Not Be Empty"
                      ) < 0
                    ) {
                      errorMessageArray.push("Account Holder Name Should Not Be Empty")
                    } else if (
                      element["Account holder name"] &&
                      element["Account holder name"]?.trim() &&
                      element["Account holder name"]?.trim()?.length > 80 &&
                      errorMessageArray.indexOf(
                        "Ensure Account Holder Name has no more than 80 characters."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Ensure Account Holder Name has no more than 80 characters."
                      );
                    } else if (
                      element["Account holder name"] &&
                      element["Account holder name"]?.trim() &&
                      !element["Account holder name"]
                        ?.trim()
                        ?.toString()
                        ?.match(isString) &&
                      errorMessageArray.indexOf(
                        "Account holder name should contain only letters and spaces. Numbers and special characters are not allowed."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Account holder name should contain only letters and spaces. Numbers and special characters are not allowed."
                      );
                    }

                    if (
                      (!element["Bank Name"] || !element["Bank Name"]?.trim()) &&
                      errorMessageArray.indexOf("Bank Name may not be blank.") <
                      0
                    ) {
                      errorMessageArray.push("Bank Name may not be blank.");
                    } else if (
                      !element["Bank Name"] &&
                      errorMessageArray.indexOf("Bank Name Should Not Be empty") < 0
                    ) {
                      errorMessageArray.push(
                        "Bank Name Should Not Be empty"
                      )
                    } else if (
                      element["Bank Name"] &&
                      element["Bank Name"]?.trim() &&
                      element["Bank Name"]?.trim().length > 48 &&
                      errorMessageArray.indexOf(
                        "Ensure Bank Name has no more than 48 characters."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Ensure Bank Name has no more than 48 characters."
                      );
                    } else if (
                      element["Bank Name"] &&
                      element["Bank Name"]?.trim() &&
                      !element["Bank Name"]?.trim().toString?.()?.match?.(isString) &&
                      errorMessageArray.indexOf(
                        "Bank Name should contain only letters and spaces. Numbers and special characters are not allowed."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Bank Name should contain only letters and spaces. Numbers and special characters are not allowed."
                      );
                    }

                    if (
                      (!element["Bank Code"] || !element["Bank Code"]?.toString()?.trim()) &&
                      errorMessageArray.indexOf("Bank Code may not be blank.") <
                      0
                    ) {
                      errorMessageArray.push("Bank Code may not be blank.");
                    } else if (
                      !element["Bank Code"] &&
                      errorMessageArray.indexOf("Bank Code Should not be empty") < 0
                    ) {
                      errorMessageArray.push("Bank Code Should not be empty")
                    } else if (
                      element["Bank Name"] &&
                      element["Bank Code"]?.toString()?.trim() &&
                      element["Bank Code"]?.toString()?.trim().length > 6 &&
                      errorMessageArray.indexOf(
                        "Ensure Bank Code has no more than 6 characters."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Ensure Bank Code has no more than 6 characters."
                      );
                    }

                    if (
                      !element["Account number"] &&
                      errorMessageArray.indexOf(
                        "Account Number may not be blank."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Account Number may not be blank."
                      );
                    } else if (
                      element["Account number"] &&
                      element["Account number"].length > 255 &&
                      errorMessageArray.indexOf(
                        "Ensure Account number has no more than 255 characters."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Ensure Account number has no more than 255 characters."
                      );
                    } else if (
                      element["Account number"] &&
                      !element["Account number"]?.toString?.()?.match?.(isNumber) &&
                      errorMessageArray.indexOf(
                        "Account number should be number only."
                      ) < 0
                    ) {
                      errorMessageArray.push(
                        "Account number should be number only."
                      );
                    }

                    if (
                      (!element["IBAN(optional)"] ||
                        !element["IBAN(optional)"]?.toString()?.trim()) &&
                      errorMessageArray.indexOf("IBAN may not be blank.") < 0
                    ) {
                      // continue;
                      // errorMessageArray.push("IBAN may not be blank.");
                    } else if (
                      !element["IBAN(optional)"] && errorMessageArray.indexOf("IBAN should not be empty.") < 0
                    ) {
                      // continue;
                      // errorMessageArray.push("IBAN should not be empty.")
                    }

                    if (!element["NIN"] && errorMessageArray.indexOf("NIN should not be empty") < 0) {
                      // should be enforced if nin is going to be included
                    } else if (element["NIN"]) {
                      let nin = element["NIN"]
                      if (
                        nin.toString().length !== 11 &&
                        errorMessageArray.indexOf("NIN should Be Eleven digits")
                      ) {
                        errorMessageArray.push("NIN should Be Eleven digits")
                      }
                    }
                    if (!element["BVN"] && errorMessageArray.indexOf("BVN should not be empty") < 0) {
                      // should be added if be is going to be enforced
                    } else if (element["BVN"]) {
                      let bvn = element["BVN"]
                      if (
                        bvn.toString().length !== 11 &&
                        errorMessageArray.indexOf("BVN should Be Eleven digits")
                      ) {
                        errorMessageArray.push("BVN should Be Eleven digits");
                      }
                    }

                  }
                } else {
                  errorMessageArray.push("No data found.");
                }

                setErrors(errorMessageArray);
                if (array && array.length) {
                  const mappedEmployees = array.map((each) => {
                    return {
                      email: each["Email"] && each["Email"]?.trim(),
                      first_name:
                        each["First Name"] && each["First Name"]?.trim(),
                      last_name:
                        each["Last Name"] && each["Last Name"]?.trim(),
                      gender: each["Gender"] ? normalizeGender(each["Gender"]) : null,
                      branch: each["Office Location"] && each["Office Location"]?.trim(),
                      employee_id: each["Employee ID"] && each["Employee ID"]?.toString()?.trim(),
                      bank: {
                        account_holder:
                          each["Account holder name"] &&
                          each["Account holder name"]?.trim(),
                        name: each["Bank Name"] && each["Bank Name"]?.trim(),
                        code: each["Bank Code"] && each["Bank Code"]?.toString()?.trim(),
                        number: each["Account number"],
                        iban: (each["IBAN(optional)"] && each["IBAN(optional)"].toString().trim()) || null,
                      },
                      withdrawal_percent: level["value"] ? level["value"].toString() : level["value"],
                      profile: {
                        position: each["Title"] && each["Title"].trim(),
                        phone: each["Phone number"],
                        salary: each["Full Net Salary"],
                        savings: each["Savings"],
                        nin: each["NIN"] && each["NIN"]?.toString(),
                        bvn: each["BVN"] && each["BVN"]?.toString()
                      },
                    };
                  });
                  setEmployees(mappedEmployees);
                  if (mappedEmployees.length) {
                    onBoardEmployeesVerifyActionMethod(mappedEmployees);
                  }
                }
                if (errorMessageArray.length) {
                  setFile(null);
                }
                setIsParsingFile(false);
              }).catch(() => {
                setErrors(["Unable to read the uploaded file. Please upload a valid .xlsx file."]);
                setFile(null);
                setEmployees([]);
                setIsVerified(false);
                setIsParsingFile(false);
              });
            }}
            accept=".xlsx"
          />
          {file?.name ? (
            <span className={classes.fileContainer}>
              <span className={classes.fileName}>{file.name}</span>
              <img
                src={"/images/cross.png"}
                alt="cross"
                className={classes.crossIcon}
                onClick={(e) => {
                  setFile(null);
                }}
              />
            </span>
          ) : null}
          {errors && errors.length ? (
            <div className={"error-container"} style={{ marginTop: "4px" }}>
              <div>
                You have the following errors, please fix them and re-upload the
                sheet again.
              </div>
              <br />
              <ol>
                {errors.map((each, index) => (
                  <li key={index}>{each}</li>
                ))}
              </ol>
            </div>
          ) : null}
          {
            (employees.length === 0 && file?.name) && (
              <div className={"error-container"}>
                <div>
                  No valid employees data found in the uploaded sheet.
                </div>
              </div>
            )
          }
        </div>

        <div style={{ marginTop: "70px" }}>
          <CommonButton
            type="button"
            text={"Submit"}
            stylevariant="secondary1"
            disabled={!file?.name || employees.length === 0 || !isVerified}
            onClick={() => {
              dispatch(onBoardEmployeesAction(employees));
            }}
          />
        </div>
      </div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setInviteEmployees(false);
          setFile(null);
        }}
      >
        <div style={modalStyle} className={classes.modalPaper}>
          <div className={classes.container}>
            <div className={classes.bingoImage}>
              <img src={"/images/success_bingo.svg"} alt="success_bingo" />
            </div>
            <div className={classes.subText} style={{ textAlign: "center" }}>
              Onboarding successful!
              <br /> Sanaam invitations have been
              <br /> sent to your employees.
            </div>
            <div style={{ marginTop: "70px" }}>
              <CommonButton
                type="button"
                text={"Done"}
                stylevariant="secondary1"
                onClick={() => {
                  setOpenModal(false);
                  setInviteEmployees(false);
                  setFile(null);
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        open={openVerifyModal}
        onClose={() => {
          setOpenVerifyModal(false);
        }}
      >
        <div style={modalStyle} className={classes.modalPaper}>
          <div className={classes.container}>
            {companyDashboardReducer?.onBoardVerifySuccess && (<><div className={classes.bingoImage}>
              <img src={"/images/success_bingo.svg"} alt="success_bingo" />
            </div>
              <div className={classes.subText} style={{ textAlign: "center" }}>
                Employees data validated successfully!
              </div>
              <div style={{ marginTop: "70px" }}>
                <CommonButton
                  type="button"
                  text={"Done"}
                  stylevariant="secondary1"
                  onClick={() => {
                    setOpenVerifyModal(false);
                  }}
                />
              </div></>)}
            {(companyDashboardReducer?.onBoardVerifyError && Array.isArray(companyDashboardReducer?.onBoardVerifyError)) && (
              <div style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}>
                {typeof companyDashboardReducer?.onBoardVerifyError === "string" && <p>{companyDashboardReducer?.onBoardVerifyError}</p>}
                {Array.isArray(companyDashboardReducer?.onBoardVerifyError) && <ValidationErrorList errors={companyDashboardReducer?.onBoardVerifyError} />}
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div >
  );
}

export default InviteEmployees;

